<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3vgGGj/tc-custom/9783965371323.jpg?1703041978158" alt="This image is the cover for the book Max Carrados, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Max Carrados, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>THE FIRST AND BEST BLIND DETECTIVE! That's how the Encyclopedia of Mystery and Detection hails the adventures of Max Carrados.  Ellery Queen calls this first volume of his adventures, "One of the ten best volumes of detective shorts ever written!" Blinded in an accident, Carrados developed remarkable abilities.  He can read newspaper headlines with a touch of his fingers, recognise a friend he has not seen in twenty-five years by his voice, and detect a man wearing a false moustache because "he carries a five-yard aura of spirit gum."  Nor did his loss of sight affect his sense of humour, his compassion, or a sense of justice which forces him to skirt the law to see the innocent is protected and the guilty punished.  As the author puts it, Carrados' blindness "-but so far from crippling his interests in life or his energies, it has merely impelled him to develop those senses which in most of us lie dormant and practically unused.  Thus you will understand that while he may be at a disadvantage while you are at an advantage, he is at an advantage while you are at a disadvantage."  Working with his old friend, Louis Carlyle, a private investigator, the wealthy Carrados pursues his talent for detection whenever he pleases without accepting a fee.  The exchanges between the humourless Carlyle, eager for Carrados help but unwilling to admit his bafflement, and the gentle malice of the perceptive Carrados are among the high spots of the stories. (Goodreads)</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ernest Bramah
      </h2>
      
      <p class="authorDescription body article">Ernest Bramah (20 March 1868 – 27 June 1942), whose name was recorded after his birth as Ernest Brammah Smith, was an English author. He published 21 books and numerous short stories and features. His humorous works were ranked with Jerome K. Jerome and W. W. Jacobs. (Wikipedia)</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      otbebookpublishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0e6088da